import 'intersection-observer'; // polyfill for iOS < 12.2 clients

export class AdVisibilityObserver {
    constructor(observedElement, viewHandler) {
        this.viewTimeout = null;
        this.observedElement = observedElement;
        this.viewedHandler = viewHandler;
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
        this.intersectionObserver = new IntersectionObserver(this.intersectionHandler, {
            threshold: [0.5]
        });
        this.intersectionObserver.observe(this.observedElement);
    }

    disconnect = () => {
        this.cancelViewTimer();
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange = () => {
        if (document.visibilityState !== 'visible') {
            this.cancelViewTimer();
        }
    }

    cancelViewTimer = () => {
        clearTimeout(this.viewTimeout);
        this.viewTimeout = null;
    }

    intersectionHandler = (entries) => {
        for (const entry of entries) {
            const ratio = entry.intersectionRatio;
            if (ratio <= 0.5) {
                this.cancelViewTimer();
            } else {
                this.startViewTimer();
            }
        }
    }

    startViewTimer = () => {
        if (this.viewTimeout) return;
        if (document.visibilityState !== 'visible') return;

        this.viewTimeout = setTimeout(() => {
            this.viewedHandler();
        }, 3000);
    }
}